/** Copy text to the clipboard. Returns true on success, false otherwise.
 *  Tries the modern async Clipboard API first, then falls back to the
 *  legacy execCommand("copy") approach via an off-screen textarea.
 */
export async function copyText(text: string): Promise<boolean> {
  // Modern path
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // fall through to legacy path
    }
  }

  // Legacy execCommand fallback
  const el = document.createElement("textarea");
  el.value = text;
  el.setAttribute("readonly", "");
  el.style.position = "fixed";
  el.style.top = "-9999px";
  el.style.left = "-9999px";
  el.style.opacity = "0";
  document.body.appendChild(el);
  el.focus();
  el.select();
  let ok = false;
  try {
    ok = document.execCommand("copy");
  } finally {
    document.body.removeChild(el);
  }
  return ok;
}
